import { HangerIcon } from './HangerIcon';

/**
 * author: Moma Design Studio
 * id 2FB0994B-BBA8-4F59-93AF-87F2065F34EA
 * name hanger
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hanger.svg
 * tags
 * - Clothing 
 * - Home Automation 
 */
export const ClothesHangerIcon = HangerIcon;
export default ClothesHangerIcon